var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.name,"vid":_vm.inputId,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var touched = ref.touched;
var errors = ref.errors;
var dirty = ref.dirty;
var failedRules = ref.failedRules;
return [_vm._t("default"),(touched && dirty && errors.length > 0)?_c('div',{staticClass:"position-absolute mt-0 ml-5 invalid-feedback"},[(typeof _vm.rules === 'string')?[_vm._v(" "+_vm._s(errors[0])+" ")]:_vm._l((failedRules),function(value,key,index){return _c('div',{key:(key + "-" + index)},[_vm._v(" "+_vm._s(_vm.rules[key])+" ")])})],2):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }